UC = UC || {};

UC.stripeBankConnection = function (args) {
    this.openModalLinkSelector = args.openModalLinkSelector;
    this.successRedirectUrl = args.successRedirectUrl || '/account/billing';
    this.successCallback = args.successCallback;
    this.exitCallback = args.exitCallback;
    this.$openModalLinkElement = $(this.openModalLinkSelector);
    this.showDefaultButtonLoader = !!args.showDefaultButtonLoader;
    if (this.showDefaultButtonLoader) {
        this.buttonLoader = this.$openModalLinkElement.buttonLoader();
    }
};

UC.stripeBankConnection.prototype = {
    init: function () {
        this.initHandler();
    },

    ensureStripeReady: function () {
        if (this.stripe) {
            return true;
        }

        this.stripe = UC.payments.createStripeClient();

        if (!this.stripe) {
            UC.utils.showNotification(UC.payments.STRIPE_NOT_READY_MESSAGE, UC.constants.results.failure);
            return false;
        }

        return true;
    },

    initHandler: function () {
        this.$openModalLinkElement.on('click', function (e) {
            e.preventDefault();

            if (!this.ensureStripeReady()) {
                return;
            }

            this.showLoader();

            UC.net.get('/account/request_ach_connection',
                function (data) {
                    this.collectBankAccountForSetup(data.client_secret, data.name, data.email);
                }.bind(this)
            ).fail(function () {
                this.hideLoader();
            }.bind(this));
        }.bind(this));
    },

    collectBankAccountForSetup: function (client_secret, name, email) {
        if (!this.ensureStripeReady()) {
            this.hideLoader();
            return;
        }

        this.stripe.collectBankAccountForSetup({
            clientSecret: client_secret, params: {
                payment_method_type: 'us_bank_account',
                payment_method_data: {
                    billing_details: {name: name, email: email},
                },
            }
        }).then(function (result) {
          if (result.error) {
              this.hideLoader();
              UC.utils.showNotification(result.error.message, UC.constants.results.failure);
          } else if (result.setupIntent) {
              if (result.setupIntent.status === 'succeeded' || result.setupIntent.status === 'requires_action') {
                  this.savePaymentMethod(result.setupIntent.id)
              } else if (result.setupIntent.status === 'requires_confirmation') {
                  this.confirmUsBankAccountSetup(client_secret, result.setupIntent.payment_method);
              } else if (result.setupIntent.status === 'requires_payment_method') {
                console.log('Connection did not establish')
                this.hideLoader();
                if (this.exitCallback) {
                  this.exitCallback();
                }
              }
          }
        }.bind(this));
    },

    confirmUsBankAccountSetup: function (client_secret, payment_method) {
        if (!this.ensureStripeReady()) {
            this.hideLoader();
            return;
        }

        this.stripe.confirmUsBankAccountSetup(
            client_secret, {payment_method: payment_method}
        ).then(function (result) {
          if (result.error) {
              this.hideLoader();
              UC.utils.showNotification(result.error.message, UC.constants.results.failure);
          } else {
              this.savePaymentMethod(result.setupIntent.id)
          }
        }.bind(this));
    },

    savePaymentMethod: function (setup_intent_id) {
        UC.net
            .post('/account/save_ach_connection', {setup_intent_id: setup_intent_id})
            .done(function (data) {
                    if (typeof this.successCallback !== 'undefined') {
                        this.successCallback();
                    } else if (data && data.payment_method_id) {
                        var href = this.successRedirectUrl;
                        if (this.successRedirectUrl.includes('?')) {
                            href += '&'
                        } else {
                            href += '?'
                        }

                        window.location.href = href + 'payment_method=' + data.payment_method_id;
                    } else {
                        window.location.href = this.successRedirectUrl;
                    }
                }.bind(this)
            ).fail(function () {
                this.hideLoader();
            }.bind(this)
        );
    },

    showLoader: function () {
        if (this.showDefaultButtonLoader) {
            this.buttonLoader.showLoader();
        } else {
            this.$openModalLinkElement.addClass('loader-enabled');
        }
    },

    hideLoader: function () {
        if (this.showDefaultButtonLoader) {
            this.buttonLoader.hideLoader();
        } else {
            this.$openModalLinkElement.removeClass('loader-enabled');
        }
    }
};
